import React, {RefObject} from 'react';
import {SCREEN_WIDTH} from 'constants/config';

/**
 * 편집 영역 > 스냅샷 컴포넌트
 */

interface IEditSnapshotProps {
  canvasRef: RefObject<HTMLCanvasElement>;
}

const EditSnapshot = ({canvasRef}: IEditSnapshotProps) => {
  return (
    <div className='vod_wrap'>
      <div className='vod_canvas'>
        <canvas
          // className="vod_image"
          id='snapshot'
          ref={canvasRef}
          width={`${SCREEN_WIDTH - 170}px`}
          height='50px'
          // style={{ width: `calc(100% - 40px)`, left: "20px" }}
        ></canvas>
      </div>
    </div>
  );
};

export default EditSnapshot;
